/* eslint-disable react/prop-types */
import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import EditModal from './edit_modal';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray, getChildCompanyUrlSuffix } from '../shared';
import Button from 'shared/button';



export default function SubSpecialties(props: SubSpecialtiesProps) {
  const [subSpecialties, setSubSpecialties] = useState<SubSpecialty[]>(props.subSpecialties);
  const [modalObject, setModalObject] = useState<{ isOpen: boolean; id: string | number }>({ isOpen: false, id: '' });
  const [error, setError] = useState<string>('');

  const openModal = (id: string | number) => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const subSpecialtyToEdit = modalObject.id === ''
    ? null
    : subSpecialties.find(subSpecialty => subSpecialty.id === modalObject.id);

  const handleFormSubmit = (newSubSpecialty: SubSpecialty) => {
    modifyRecordArray(newSubSpecialty, setSubSpecialties, subSpecialties, 'title', modalObject, closeModal);
  };

  const deleteSubSpecialty = ({ title, id }: { title: string; id: number }) => {
    const urlSuffix = getChildCompanyUrlSuffix();
    deleteRecord(id, title, '/sub_specialties', 'SubSpecialty', setSubSpecialties, setError, urlSuffix);
  };

  const addNewSubSpecialty = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        dialogClassName="modal-sm"
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          id={modalObject.id}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          title={subSpecialtyToEdit?.title}
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 align-items-center top-buffer-xl">
        <h2 className="m-0">Broker & Company Sub-Specialties</h2>
        <Button.Primary onClick={addNewSubSpecialty}>Add Sub-Specialty</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Sub-Specialty"
        deleteRecord={deleteSubSpecialty}
        firstColumnIdentifier="title"
        openModal={openModal}
        recordName="Sub-Specialty"
        records={subSpecialties}
        secondColumnIdentifier="propertyType"
        onClick={addNewSubSpecialty}
      />

    </React.Fragment>
  );
}

export type SubSpecialty = {
  canModify: boolean;
  id: number;
  title: string;
};

interface SubSpecialtiesProps {
  subSpecialties: SubSpecialty[];
}
